import React, { Component } from "react";
import WaveSurfer from "wavesurfer.js";
import PropTypes from 'prop-types'
import { WaveformContianer, Wave, PlayButton } from "./Waveform.styled";

class ScrollWaveform extends Component {
  state = {
    playing: false
  };

  componentDidMount() {
    const track = document.querySelector("#track");

    this.waveform = WaveSurfer.create({
      barWidth: 3,
      barRadius: 3,
      barGap: 2,
      barMinHeight: 1,
      cursorWidth: 1,
      container: "#wavefkkorm",
      backend: "WebAudio",
      autoCenter: true,
      progressColor: "#FE6E00",
      hideScrollbar:true,
      responsive: false,
      splitChannels:false,
      waveColor: "#C4C4C4",
      cursorColor: "transparent"
    });

    this.waveform.load(track);
  }

  handlePlay = () => {
    this.setState({ playing: !this.state.playing });
    this.waveform.playPause();
  };

  render({audiourl}) {
    const url =
      "https://api.twilio.com//2010-04-01/Accounts/AC25aa00521bfac6d667f13fec086072df/Recordings/RE6d44bc34911342ce03d6ad290b66580c.mp3";

    return (
      <WaveformContianer>
        <PlayButton onClick={this.handlePlay}>
          {!this.state.playing ? "Play" : "Pause"}
        </PlayButton>
        <Wave id="wavefkkorm"/>
        <audio id="track" src={audiourl?audiourl:url} />
        <div>0.52</div>
      </WaveformContianer>
    ); 
  }
}
ScrollWaveform.PropTypes={
  audiourl:PropTypes.string.isRequired,
}
export default ScrollWaveform;
